import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import './App.css';
import HomePage from './HomePage';
import FeaturesPage from './features/FeaturesPage';
import AgentsSuite from './features/AgentsSuite';
import NewsSuite from './features/NewsSuite';
import NumbersSuite from './features/NumbersSuite';
import TextsVideosSuite from './features/TextsVideosSuite';
import SmartSearchSuite from './features/SmartSearchSuite';
import SignalsSuite from './features/SignalsSuite';
import PredictiveSignals from './features/PredictiveSignals';
import CreativeCanvas from './features/CreativeCanvas';
import Discover from './features/Discover';
import IdeaMakerSuite from './features/IdeaMakerSuite';
import VisualizationSuite from './features/VisualizationSuite';
import AIMarketDecoder from './features/AIMarketDecoder/AIMarketDecoder';
import MicroProbe from './features/AIMarketDecoder/MicroProbe/MicroProbe';
import ContactPage from './features/ContactPage';
import HelpPage from './features/HelpPage';
import ForeignExchangeFrontPage from './features/AIMarketDecoder/ForeignExchange/ForeignExchangeFrontPage';
import Companies from './features/AIMarketDecoder/MicroProbe/Companies/Companies';
import CurrencyPairs from './features/AIMarketDecoder/ForeignExchange/CurrencyPairs/CurrencyPairs';
import CurrencyPairsNews from './features/AIMarketDecoder/ForeignExchange/CurrencyPairs/CurrencyPairsNews';
import EconomyFrontPage from './features/AIMarketDecoder/Economy/EconomyFrontPage';
import Countries from './features/AIMarketDecoder/Economy/Countries/Countries';
import CommodityFrontPage from './features/AIMarketDecoder/Commodity/CommodityFrontPage';
import IndividualCommodity from './features/AIMarketDecoder/Commodity/IndividualCommodity/IndividualCommodity';
import CrytoFrontPage from './features/AIMarketDecoder/Crypto/CryptoFrontPage';
import IndividualCrypto from './features/AIMarketDecoder/Crypto/IndividualCrypto/IndividualCrypto';
import BondFrontPage from './features/AIMarketDecoder/Bond/BondFrontPage';
import IndividualBond from './features/AIMarketDecoder/Bond/IndividualBond/IndividualBond';
import IndividualBondNews from './features/AIMarketDecoder/Bond/IndividualBond/IndividualBondNews';
import InvididualCryptoNews from './features/AIMarketDecoder/Crypto/IndividualCrypto/IndividualCryptoNews';
import InvididualCommodityNews from './features/AIMarketDecoder/Commodity/IndividualCommodity/IndividualCommodityNews';
import CompaniesNews from './features/AIMarketDecoder/MicroProbe/Companies/CompaniesNews';
import CountriesNews from './features/AIMarketDecoder/Economy/Countries/CountriesNews';
import IndividualBondNumbers from './features/AIMarketDecoder/Bond/IndividualBond/IndividualBondNumbers';
import IndividualCommodityNumbers from './features/AIMarketDecoder/Commodity/IndividualCommodity/IndividualCommodityNumbers';
import IndividualCryptoNumbers from './features/AIMarketDecoder/Crypto/IndividualCrypto/IndividualCryptoNumbers';
import CountriesNumbers from './features/AIMarketDecoder/Economy/Countries/CountriesNumbers';
import CompaniesNumbers from './features/AIMarketDecoder/MicroProbe/Companies/CompaniesNumbers';
import CurrencyPairsNumbers from './features/AIMarketDecoder/ForeignExchange/CurrencyPairs/CurrencyPairsNumbers';
import IndividualBondSignals from './features/AIMarketDecoder/Bond/IndividualBond/IndividualBondSignals';
import IndividualCommoditySignals from './features/AIMarketDecoder/Commodity/IndividualCommodity/IndividualCommoditySignals';
import IndividualCryptoSignals from './features/AIMarketDecoder/Crypto/IndividualCrypto/IndividualCryptoSignals';
import CountriesSignals from './features/AIMarketDecoder/Economy/Countries/CountriesSignals';
import CompaniesSignals from './features/AIMarketDecoder/MicroProbe/Companies/CompaniesSignals';
import CurrencyPairsSignals from './features/AIMarketDecoder/ForeignExchange/CurrencyPairs/CurrencyPairsSignals';
import CompaniesEarnings from './features/AIMarketDecoder/MicroProbe/Companies/CompaniesEarnings';
import CompaniesSEC from './features/AIMarketDecoder/MicroProbe/Companies/CompaniesSEC';
import VideoInsight from './features/AIMarketDecoder/MicroProbe/MicroProbeVideos';
import DocumentUpload from './features/AIMarketDecoder/MicroProbe/MicroProbeDocumentsCompare';
import TopicGather from './features/AIMarketDecoder/MicroProbe/MicroProbeTopicGather';
import InsightExplorer from './features/AIMarketDecoder/MicroProbe/Companies/InsightExplorer';
import AgenticChat from './features/AIMarketDecoder/FinaAgents/AgenticChat';
import Orchestrator from './features/AIMarketDecoder/FinaOrchestrator/Orchestrator';
import PrivateRoute from './PrivateRoute';
import Login from './Login';
import Header from './Header';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faNewspaper,
  faChartBar,
  faFileAlt,
  faWaveSquare,
  faFileInvoice,
  faSearch,
  faRobot,
  faSitemap,
  faEye,
  faNetworkWired,
  faChartLine
} from '@fortawesome/free-solid-svg-icons';

// ─── Scroll to top on navigation ────────────────────────────────────────────
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

// ─── Sidebar (original collapsible) ──────────────────────────────────────────
const Sidebar = () => {
  const [isCollapsed, setCollapsed] = useState(true);
  const location = useLocation();

  const sections = [
    {
      label: 'EXPLORE',
      items: [
        { name: 'Smart Search', path: '/smart-search-suite', icon: faSearch },
        { name: 'Live Themes', path: '/live-themes', icon: faNewspaper },
        { name: 'Unstructured Insights', path: '/unstructured-insights', icon: faFileAlt },
      ]
    },
    {
      label: 'ANALYZE',
      items: [
        { name: 'Entity Intelligence', path: '/entity-intelligence', icon: faEye },
        { name: 'Research Analyst', path: '/research-analyst', icon: faChartLine },
        { name: 'Historical Analysis', path: '/historical-analysis', icon: faChartBar },
        { name: 'Predictive Signals', path: '/signals-suite', icon: faWaveSquare },
      ]
    },
    {
      label: 'CONNECT',
      items: [
        { name: 'Dynamic Visualization', path: '/visualization-suite', icon: faNetworkWired },
        { name: 'Report & Idea Studio', path: '/ideas-maker', icon: faFileInvoice },
      ]
    },
    {
      label: 'FINA AGENT',
      items: [
        { name: 'Ask Fina', path: '/fina-agent', icon: faRobot },
        { name: 'Fina Collective', path: '/fina-collective', icon: faSitemap },
      ]
    }
  ];

  return (
    <div className={`sidebar ${isCollapsed ? 'collapsed' : ''}`}>
      <button onClick={() => setCollapsed(!isCollapsed)}>
        {isCollapsed ? '>' : '<'}
      </button>
      <nav>
        {isCollapsed ? (
          sections.flatMap(section =>
            section.items.map(item => (
              <Link
                key={item.path}
                to={item.path}
                data-tooltip={item.name}
                className={location.pathname === item.path ? 'active' : ''}
              >
                <FontAwesomeIcon icon={item.icon} className="icon" />
              </Link>
            ))
          )
        ) : (
          sections.map(section => (
            <div key={section.label} className="sidebar-flat-section">
              <div className="section-label">{section.label}</div>
              <div className="section-items">
                {section.items.map(item => (
                  <Link
                    key={item.path}
                    to={item.path}
                    className={location.pathname === item.path ? 'active' : ''}
                  >
                    <FontAwesomeIcon icon={item.icon} className="icon" />
                    <span className="text">{item.name}</span>
                    {item.badge && <span className="nav-badge">{item.badge}</span>}
                  </Link>
                ))}
              </div>
            </div>
          ))
        )}
      </nav>
    </div>
  );
};

// ─── Footer (original) ────────────────────────────────────────────────────────
const Footer = () => (
  <footer>
    <h1><Link to="/help">Help</Link> | <Link to="/contact">Contact</Link></h1>
    <p>© 2026 Fina.ai</p>
  </footer>
);

// ─── App ──────────────────────────────────────────────────────────────────────
const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('access_token'));

  // Tooltip functionality for collapsed sidebar
  useEffect(() => {
    const handleTooltips = () => {
      const sidebarLinks = document.querySelectorAll('.sidebar.collapsed nav a[data-tooltip]');
      sidebarLinks.forEach(link => {
        const showTooltip = (e) => {
          document.querySelectorAll('.custom-tooltip').forEach(t => t.remove());
          const tooltip = document.createElement('div');
          tooltip.className = 'custom-tooltip';
          tooltip.textContent = link.getAttribute('data-tooltip');
          tooltip.style.cssText = `
            position: fixed;
            left: 70px;
            top: ${e.clientY}px;
            transform: translateY(-50%);
            background: #1a202c;
            color: #f1f5f9;
            padding: 8px 12px;
            border-radius: 6px;
            white-space: nowrap;
            z-index: 99999;
            font-size: 0.9rem;
            font-weight: 500;
            border: 1px solid rgba(6, 182, 212, 0.3);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
            pointer-events: none;
          `;
          document.body.appendChild(tooltip);
        };
        const hideTooltip = () => {
          document.querySelectorAll('.custom-tooltip').forEach(t => t.remove());
        };
        link.addEventListener('mouseenter', showTooltip);
        link.addEventListener('mouseleave', hideTooltip);
      });
    };
    const timer = setTimeout(handleTooltips, 100);
    return () => {
      clearTimeout(timer);
      document.querySelectorAll('.custom-tooltip').forEach(t => t.remove());
    };
  }, [isAuthenticated]);

  const handleLogout = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    setIsAuthenticated(false);
    window.location.href = '/login';
  };

  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Header onLogout={handleLogout} isAuthenticated={isAuthenticated} />
        <div className="wrapper">
          <div className="main-content">
            {isAuthenticated && <Sidebar />}
            <div className="content-area">
              <Routes>
                <Route path="/login" element={<Login setIsAuthenticated={setIsAuthenticated} />} />
                <Route path="/" element={<PrivateRoute isAuthenticated={isAuthenticated}><HomePage /></PrivateRoute>} />
                <Route path="/features" element={<PrivateRoute isAuthenticated={isAuthenticated}><FeaturesPage /></PrivateRoute>} />
                <Route path="/help" element={<PrivateRoute isAuthenticated={isAuthenticated}><HelpPage /></PrivateRoute>} />
                <Route path="/contact" element={<PrivateRoute isAuthenticated={isAuthenticated}><ContactPage /></PrivateRoute>} />
                <Route path="/entity-intelligence" element={<PrivateRoute isAuthenticated={isAuthenticated}><AIMarketDecoder /></PrivateRoute>} />
                <Route path="/research-analyst" element={<PrivateRoute isAuthenticated={isAuthenticated}><AgentsSuite /></PrivateRoute>} />
                <Route path="/live-themes" element={<PrivateRoute isAuthenticated={isAuthenticated}><NewsSuite /></PrivateRoute>} />
                <Route path="/topic-gather" element={<PrivateRoute isAuthenticated={isAuthenticated}><TopicGather /></PrivateRoute>} />
                <Route path="/historical-analysis" element={<PrivateRoute isAuthenticated={isAuthenticated}><NumbersSuite /></PrivateRoute>} />
                <Route path="/unstructured-insights" element={<PrivateRoute isAuthenticated={isAuthenticated}><TextsVideosSuite /></PrivateRoute>} />
                <Route path="/smart-search-suite" element={<PrivateRoute isAuthenticated={isAuthenticated}><SmartSearchSuite /></PrivateRoute>} />
                <Route path="/signals-suite" element={<PrivateRoute isAuthenticated={isAuthenticated}><SignalsSuite /></PrivateRoute>} />
                <Route path="/predictive-signals" element={<PrivateRoute isAuthenticated={isAuthenticated}><PredictiveSignals /></PrivateRoute>} />
                <Route path="/intelligence-studio" element={<PrivateRoute isAuthenticated={isAuthenticated}><CreativeCanvas /></PrivateRoute>} />
                <Route path="/discover" element={<PrivateRoute isAuthenticated={isAuthenticated}><Discover /></PrivateRoute>} />
                <Route path="/visualization-suite" element={<PrivateRoute isAuthenticated={isAuthenticated}><VisualizationSuite /></PrivateRoute>} />
                <Route path="/ideas-maker" element={<PrivateRoute isAuthenticated={isAuthenticated}><IdeaMakerSuite /></PrivateRoute>} />
                <Route path="/companies" element={<PrivateRoute isAuthenticated={isAuthenticated}><MicroProbe /></PrivateRoute>} />
                <Route path="/foreign-exchange" element={<PrivateRoute isAuthenticated={isAuthenticated}><ForeignExchangeFrontPage /></PrivateRoute>} />
                <Route path="/economy" element={<PrivateRoute isAuthenticated={isAuthenticated}><EconomyFrontPage /></PrivateRoute>} />
                <Route path="/commodity" element={<PrivateRoute isAuthenticated={isAuthenticated}><CommodityFrontPage /></PrivateRoute>} />
                <Route path="/crypto" element={<PrivateRoute isAuthenticated={isAuthenticated}><CrytoFrontPage /></PrivateRoute>} />
                <Route path="/bond" element={<PrivateRoute isAuthenticated={isAuthenticated}><BondFrontPage /></PrivateRoute>} />
                <Route path="/company-details/:companyName" element={<PrivateRoute isAuthenticated={isAuthenticated}><Companies /></PrivateRoute>} />
                <Route path="/foreignexchange-details/:foreignExchangeName" element={<PrivateRoute isAuthenticated={isAuthenticated}><CurrencyPairs /></PrivateRoute>} />
                <Route path="/foreignexchange-news/:foreignExchangeName" element={<PrivateRoute isAuthenticated={isAuthenticated}><CurrencyPairsNews /></PrivateRoute>} />
                <Route path="/commodity-details/:commodityName" element={<PrivateRoute isAuthenticated={isAuthenticated}><IndividualCommodity /></PrivateRoute>} />
                <Route path="/crypto-details/:cryptoName" element={<PrivateRoute isAuthenticated={isAuthenticated}><IndividualCrypto /></PrivateRoute>} />
                <Route path="/economy-details/:economyName" element={<PrivateRoute isAuthenticated={isAuthenticated}><Countries /></PrivateRoute>} />
                <Route path="/bond-details/:economyName" element={<PrivateRoute isAuthenticated={isAuthenticated}><IndividualBond /></PrivateRoute>} />
                <Route path="/bond-news/:economyName" element={<PrivateRoute isAuthenticated={isAuthenticated}><IndividualBondNews /></PrivateRoute>} />
                <Route path="/crypto-news/:cryptoName" element={<PrivateRoute isAuthenticated={isAuthenticated}><InvididualCryptoNews /></PrivateRoute>} />
                <Route path="/commodity-news/:commodityName" element={<PrivateRoute isAuthenticated={isAuthenticated}><InvididualCommodityNews /></PrivateRoute>} />
                <Route path="/economy-news/:economyName" element={<PrivateRoute isAuthenticated={isAuthenticated}><CountriesNews /></PrivateRoute>} />
                <Route path="/company-news/:companyName" element={<PrivateRoute isAuthenticated={isAuthenticated}><CompaniesNews /></PrivateRoute>} />
                <Route path="/bond-numbers/:economyName" element={<PrivateRoute isAuthenticated={isAuthenticated}><IndividualBondNumbers /></PrivateRoute>} />
                <Route path="/commodity-numbers/:commodityName" element={<PrivateRoute isAuthenticated={isAuthenticated}><IndividualCommodityNumbers /></PrivateRoute>} />
                <Route path="/crypto-numbers/:cryptoName" element={<PrivateRoute isAuthenticated={isAuthenticated}><IndividualCryptoNumbers /></PrivateRoute>} />
                <Route path="/economy-numbers/:economyName" element={<PrivateRoute isAuthenticated={isAuthenticated}><CountriesNumbers /></PrivateRoute>} />
                <Route path="/company-numbers/:companyName" element={<PrivateRoute isAuthenticated={isAuthenticated}><CompaniesNumbers /></PrivateRoute>} />
                <Route path="/foreignexchange-numbers/:foreignExchangeName" element={<PrivateRoute isAuthenticated={isAuthenticated}><CurrencyPairsNumbers /></PrivateRoute>} />
                <Route path="/bond-signals/:economyName" element={<PrivateRoute isAuthenticated={isAuthenticated}><IndividualBondSignals /></PrivateRoute>} />
                <Route path="/commodity-signals/:commodityName" element={<PrivateRoute isAuthenticated={isAuthenticated}><IndividualCommoditySignals /></PrivateRoute>} />
                <Route path="/crypto-signals/:cryptoName" element={<PrivateRoute isAuthenticated={isAuthenticated}><IndividualCryptoSignals /></PrivateRoute>} />
                <Route path="/economy-signals/:economyName" element={<PrivateRoute isAuthenticated={isAuthenticated}><CountriesSignals /></PrivateRoute>} />
                <Route path="/company-signals/:companyName" element={<PrivateRoute isAuthenticated={isAuthenticated}><CompaniesSignals /></PrivateRoute>} />
                <Route path="/foreignexchange-signals/:foreignExchangeName" element={<PrivateRoute isAuthenticated={isAuthenticated}><CurrencyPairsSignals /></PrivateRoute>} />
                <Route path="/company-earnings/:companyName" element={<PrivateRoute isAuthenticated={isAuthenticated}><CompaniesEarnings /></PrivateRoute>} />
                <Route path="/company-sec-fillings/:companyName" element={<PrivateRoute isAuthenticated={isAuthenticated}><CompaniesSEC /></PrivateRoute>} />
                <Route path="/videos" element={<PrivateRoute isAuthenticated={isAuthenticated}><VideoInsight /></PrivateRoute>} />
                <Route path="/documents" element={<PrivateRoute isAuthenticated={isAuthenticated}><DocumentUpload /></PrivateRoute>} />
                <Route path="/insight-explorer" element={<PrivateRoute isAuthenticated={isAuthenticated}><InsightExplorer /></PrivateRoute>} />
                <Route path="/fina-agent" element={<PrivateRoute isAuthenticated={isAuthenticated}><AgenticChat /></PrivateRoute>} />
                <Route path="/fina-collective" element={<PrivateRoute isAuthenticated={isAuthenticated}><Orchestrator /></PrivateRoute>} />
              </Routes>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </Router>
  );
};


export default App;